/* =========================================================
   CASA MIMIDO — UPLOADKIT PRODUCT UI
   Mini Archive + Single Custom Mimido
========================================================= */


/* =========================================================
   SHARED HELPERS
========================================================= */

function getMimidoUploadWrap() {
  return (
    document.querySelector('.uploadkit.uploadkit-app-block') ||
    document.querySelector('.uploadkit.uploadkit-injected') ||
    document.querySelector('.uploadkit')
  );
}


function getMimidoProductData(uploadWrap) {
  return (
    uploadWrap?.getAttribute('data-uploadkit-product-json') || ''
  ).toLowerCase();
}


/* =========================================================
   MINI ARCHIVE
========================================================= */

function initMiniArchiveAccordion() {

  const uploadWrap =
    getMimidoUploadWrap();

  if (!uploadWrap) return false;


  const productData =
    getMimidoProductData(
      uploadWrap
    );


  if (
    !productData.includes(
      'mini archive'
    )
  ) {
    return false;
  }


  let uploadFields =
    Array.from(
      uploadWrap.querySelectorAll(
        '.uploadkit-upload-field'
      )
    );


  if (!uploadFields.length) {

    uploadFields =
      Array.from(
        uploadWrap.querySelectorAll(
          '.uploadkit-uploader'
        )
      );
  }


  if (
    uploadFields.length < 2
  ) {
    return false;
  }


  const addToCartButton =
    document.querySelector(
      'button[name="add"]'
    );


  const productForm =
    addToCartButton?.closest(
      'form.shopify-product-form'
    ) ||
    addToCartButton?.closest(
      'form'
    );


  if (!productForm) {
    return false;
  }

  const miniValidators =
    [];


  const productFormComponent =
    productForm.closest(
      'product-form-component'
    );


  const validationDialog =
    document.createElement(
      'dialog'
    );


  validationDialog.className =
    'mimido-mini-validation-dialog';


  validationDialog.setAttribute(
    'aria-labelledby',
    'mimido-mini-validation-title'
  );


  validationDialog.innerHTML = `
    <div class="mimido-mini-validation-dialog__content">
      <button
        type="button"
        class="mimido-mini-validation-dialog__close"
        aria-label="Close"
      >
        ×
      </button>
      <h2 id="mimido-mini-validation-title">
        One more thing!
      </h2>
      <p class="mimido-mini-validation-dialog__intro">
        Please complete the following before continuing.
      </p>
      <ul class="mimido-mini-validation-dialog__list"></ul>
      <button
        type="button"
        class="button mimido-mini-validation-dialog__ok"
      >
        OK
      </button>
    </div>
  `;


  document.body.appendChild(
    validationDialog
  );


  const validationDialogList =
    validationDialog.querySelector(
      '.mimido-mini-validation-dialog__list'
    );


  const validationDialogClose =
    validationDialog.querySelector(
      '.mimido-mini-validation-dialog__close'
    );


  const validationDialogOk =
    validationDialog.querySelector(
      '.mimido-mini-validation-dialog__ok'
    );


  let validationDialogTrigger =
    null;


  function formatMiniNumbers(
    numbers
  ) {

    const labels =
      numbers.map(
        number =>
          `Mini ${number}`
      );


    if (labels.length < 2) {
      return labels[0];
    }


    if (labels.length === 2) {
      return labels.join(' and ');
    }


    return `${labels
      .slice(0, -1)
      .join(', ')}, and ${labels.at(-1)}`;
  }


  function closeValidationDialog() {

    if (validationDialog.open) {
      validationDialog.close();
    }
  }


  function showValidationDialog(
    validationErrors
  ) {

    const photoMinis =
      validationErrors
        .filter(
          error =>
            error.type === 'photo'
        )
        .map(
          error =>
            error.number
        );


    const instagramMinis =
      validationErrors
        .filter(
          error =>
            error.type === 'instagram'
        )
        .map(
          error =>
            error.number
        );


    validationDialogList.textContent =
      '';


    if (photoMinis.length) {

      const item =
        document.createElement(
          'li'
        );


      item.textContent =
        `Please upload at least one photo for ${formatMiniNumbers(
          photoMinis
        )} before adding your set to the cart.`;


      validationDialogList.appendChild(
        item
      );
    }


    if (instagramMinis.length) {

      const item =
        document.createElement(
          'li'
        );


      item.textContent =
        `Please enter an Instagram @ for ${formatMiniNumbers(
          instagramMinis
        )} before adding your set to the cart.`;


      validationDialogList.appendChild(
        item
      );
    }


    if (!validationDialog.open) {

      validationDialogTrigger =
        document.activeElement;


      validationDialog.showModal();
    }


    requestAnimationFrame(
      () => {
        validationDialogClose.focus();
      }
    );
  }


  validationDialogClose.addEventListener(
    'click',
    closeValidationDialog
  );


  validationDialogOk.addEventListener(
    'click',
    closeValidationDialog
  );


  validationDialog.addEventListener(
    'cancel',
    event => {

      event.preventDefault();


      closeValidationDialog();
    }
  );


  validationDialog.addEventListener(
    'click',
    event => {

      if (event.target === validationDialog) {
        closeValidationDialog();
      }
    }
  );


  validationDialog.addEventListener(
    'close',
    () => {

      validationDialogTrigger?.focus?.();


      validationDialogTrigger =
        null;
    }
  );


  document.body.classList.add(
    'mini-archive-page'
  );


  /* =====================================================
     OUTER FRAME
  ===================================================== */

  uploadWrap.style.border =
    '1px solid #e8dfdf';

  uploadWrap.style.padding =
    '22px';

  uploadWrap.style.boxSizing =
    'border-box';

  uploadWrap.style.background =
    'transparent';

  uploadWrap.style.marginTop =
    '0';

  uploadWrap.style.marginBottom =
    '24px';


  /* =====================================================
     ARCHIVE INTRO
  ===================================================== */

  if (
    !uploadWrap.dataset.archiveWrapperReady
  ) {

    const intro =
      document.createElement(
        'div'
      );


    intro.className =
      'mini-archive-intro';


    intro.innerHTML = `
      <div class="mini-archive-heading">
        BUILD YOUR MINI ARCHIVE
      </div>

      <div class="mini-archive-subheading">
        Upload references and share your ideas for each mini.
      </div>
    `;


    uploadWrap.prepend(
      intro
    );


    uploadWrap.dataset.archiveWrapperReady =
      'true';
  }


  /* =====================================================
     EACH MINI
  ===================================================== */

  uploadFields.forEach(
    (field, index) => {

      if (
        field.dataset.archiveReady ===
        'true'
      ) {
        return;
      }


      const label =
        field.querySelector(
          '.uploadkit-label'
        );


      if (!label) return;


      const number =
        String(index + 1)
          .padStart(2, '0');


      const uploadPropertyPrefix =
        `properties[_Mini ${number} Upload`;


      function isMiniUploadProperty(
        name
      ) {

        return (
          name ===
          `${uploadPropertyPrefix}]` ||
          name.startsWith(
            `${uploadPropertyPrefix} `
          )
        );
      }


      function getMiniUploadControls() {

        return Array.from(
          document.querySelectorAll(
            'input[name], textarea[name], select[name]'
          )
        ).filter(
          control =>
            control.form === productForm &&
            isMiniUploadProperty(
              control.name
            )
        );
      }


      function setMiniUploadSubmissionEnabled(
        enabled
      ) {

        getMiniUploadControls().forEach(
          control => {
            control.disabled =
              !enabled;
          }
        );
      }


      function hasMiniUploadedFiles() {

        const formData =
          new FormData(
            productForm
          );


        return Array.from(
          formData.entries()
        ).some(
          ([name, value]) => {

            if (
              !isMiniUploadProperty(name) ||
              typeof value !== 'string' ||
              !value.trim()
            ) {
              return false;
            }


            try {
              const uploadedFileUrl =
                new URL(
                  value.trim()
                );


              return (
                uploadedFileUrl.protocol ===
                'https:' ||
                uploadedFileUrl.protocol ===
                'http:'
              );
            } catch (_) {
              return false;
            }
          }
        );
      }


      /* =================================================
         SAVE ORIGINAL UPLOADKIT CONTENT
      ================================================= */

      const originalContent =
        Array.from(
          field.children
        ).filter(
          child =>
            child !== label
        );


      originalContent.forEach(
        child => {

          child.classList.add(
            'archive-original-content'
          );
        }
      );


      /* =================================================
         MINI HEADER
      ================================================= */

      label.innerHTML = `
        <span class="archive-mini-number">
          ${number}
        </span>

        <span class="archive-mini-text">
          <strong>
            Mini ${number}
          </strong>

          <small>
            Add photos and notes for Mini ${number}
          </small>
        </span>

        <span class="archive-mini-toggle">
          ⌄
        </span>
      `;


      /* =================================================
         CREATE MODE UI
      ================================================= */

      const creator =
        document.createElement(
          'div'
        );


      creator.className =
        'archive-mini-creator';


      creator.innerHTML = `

        <div class="archive-create-heading">
          HOW WOULD YOU LIKE TO CREATE MINI ${number}?
        </div>


        <div class="archive-mode-tabs">

          <button
            type="button"
            class="archive-mode-tab active"
            data-mode="known"
            aria-pressed="true"
          >
            I KNOW WHAT I WANT
          </button>


          <button
            type="button"
            class="archive-mode-tab"
            data-mode="surprise"
            aria-pressed="false"
          >
            SURPRISE ME
          </button>

        </div>


        <div class="archive-content-panel">

          <div
            class="archive-surprise-controls mimido-hidden"
          >

            <div class="archive-surprise-heading">
              HOW SHOULD WE CHOOSE YOUR LOOK?
            </div>


            <div class="archive-source-tabs">

              <button
                type="button"
                class="archive-source-tab active"
                data-source="looks"
                aria-pressed="true"
              >
                FROM MY LOOKS
              </button>


              <button
                type="button"
                class="archive-source-tab"
                data-source="instagram"
                aria-pressed="false"
              >
                FROM MY INSTAGRAM
              </button>

            </div>

          </div>


          <div class="archive-context">

            <div class="archive-context-heading">
              YOUR REFERENCES
            </div>

            <div class="archive-context-text">
              Upload the reference(s) you'd like us to follow.
            </div>

          </div>


          <div
            class="archive-instagram-panel mimido-hidden"
          >

            <div class="archive-instagram-field">

              <label>
                Instagram @
              </label>

              <input
                type="text"
                class="archive-instagram-handle"
                autocomplete="off"
                placeholder="@yourhandle"
              >

              <div class="archive-instagram-help">
                Please make sure the account is public and includes clear photos we can reference.
              </div>

            </div>


            <div class="archive-instagram-field">

              <label>
                Anything we should know?

                <span class="mimido-optional-label">
                  (optional)
                </span>
              </label>

              <textarea
                class="archive-instagram-note"
                placeholder="A favorite style, something to avoid, or leave it completely to us."
              ></textarea>

            </div>

          </div>


          <div
            class="archive-upload-footnote mimido-hidden"
          >
            Multiple photos per look are welcome.
          </div>

        </div>
      `;


      field.insertBefore(
        creator,
        label.nextSibling
      );


      const contentPanel =
        creator.querySelector(
          '.archive-content-panel'
        );


      /*
        把 UploadKit 原来的上传区域
        搬到白色 inner panel 内。
      */

      originalContent.forEach(
        child => {

          contentPanel.insertBefore(
            child,
            creator.querySelector(
              '.archive-upload-footnote'
            )
          );
        }
      );


      /* =================================================
         STATE
      ================================================= */

      let currentMode =
        'known';


      let currentSource =
        'looks';


      const modeTabs =
        creator.querySelectorAll(
          '.archive-mode-tab'
        );


      const sourceTabs =
        creator.querySelectorAll(
          '.archive-source-tab'
        );


      const surpriseControls =
        creator.querySelector(
          '.archive-surprise-controls'
        );


      const contextHeading =
        creator.querySelector(
          '.archive-context-heading'
        );


      const contextText =
        creator.querySelector(
          '.archive-context-text'
        );


      const instagramPanel =
        creator.querySelector(
          '.archive-instagram-panel'
        );


      const instagramHandle =
        creator.querySelector(
          '.archive-instagram-handle'
        );


      const uploadFootnote =
        creator.querySelector(
          '.archive-upload-footnote'
        );


      const instagramNote =
        creator.querySelector(
          '.archive-instagram-note'
        );


      const errorBox =
        document.createElement(
          'div'
        );


      errorBox.className =
        'archive-mini-error';


      errorBox.setAttribute(
        'aria-live',
        'polite'
      );


      errorBox.hidden =
        true;


      contentPanel.appendChild(
        errorBox
      );


      function createMiniProperty(
        label,
        value = ''
      ) {

        const input =
          document.createElement(
            'input'
          );


        input.type =
          'hidden';


        input.name =
          `properties[Mini ${number} - ${label}]`;


        input.value =
          value;


        productForm.appendChild(
          input
        );


        return input;
      }


      const miniNumberProperty =
        createMiniProperty(
          'Number',
          number
        );


      const creationModeProperty =
        createMiniProperty(
          'Creation Mode',
          'I Know What I Want'
        );


      const surpriseSourceProperty =
        createMiniProperty(
          'Surprise Source'
        );


      surpriseSourceProperty.disabled =
        true;


      const instagramProperty =
        createMiniProperty(
          'Instagram @'
        );


      instagramProperty.disabled =
        true;


      const instagramNoteProperty =
        createMiniProperty(
          'Surprise Note'
        );


      instagramNoteProperty.disabled =
        true;


      function showMiniError(
        message
      ) {

        errorBox.textContent =
          message;


        errorBox.hidden =
          false;


        errorBox.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        });
      }


      function clearMiniError() {

        errorBox.textContent =
          '';


        errorBox.hidden =
          true;
      }


      /* =================================================
         UPLOAD BUTTON TEXT
      ================================================= */

      function updateArchiveUploadText() {

        const button =
          field.querySelector(
            '.uploadkit-button'
          );


        if (!button) {
          return;
        }


        const desiredText =
          currentMode === 'surprise' &&
          currentSource === 'looks'
            ? 'Add 3–5 looks'
            : 'Add photos';


        const currentText =
          button
            .textContent
            .trim()
            .toLowerCase();


        /*
          如果已经上传，
          UploadKit 可能显示 Change image，
          这时候不要覆盖。
        */

        if (
          currentText.includes(
            'change'
          )
        ) {
          return;
        }


        if (
          button.textContent.trim() !==
          desiredText
        ) {

          button.textContent =
            desiredText;
        }
      }


      /* =================================================
         RENDER
      ================================================= */

      function renderArchiveMode() {

        clearMiniError();

        /* -----------------------------
           I KNOW WHAT I WANT
        ----------------------------- */

        if (
          currentMode === 'known'
        ) {

          surpriseControls.classList.add(
            'mimido-hidden'
          );


          instagramPanel.classList.add(
            'mimido-hidden'
          );


          field.classList.remove(
            'archive-instagram-mode'
          );


          contextHeading.textContent =
            'YOUR REFERENCES';


          contextText.textContent =
            "Upload the reference(s) you'd like us to follow.";


          uploadFootnote.classList.add(
            'mimido-hidden'
          );


          creationModeProperty.value =
            'I Know What I Want';


          surpriseSourceProperty.value =
            '';


          surpriseSourceProperty.disabled =
            true;


          instagramProperty.value =
            '';


          instagramProperty.disabled =
            true;


          instagramNoteProperty.value =
            '';


          instagramNoteProperty.disabled =
            true;


          setMiniUploadSubmissionEnabled(
            true
          );
        }


        /* -----------------------------
           SURPRISE ME
        ----------------------------- */

        if (
          currentMode === 'surprise'
        ) {

          surpriseControls.classList.remove(
            'mimido-hidden'
          );


          creationModeProperty.value =
            'Surprise Me';


          surpriseSourceProperty.disabled =
            false;


          /* FROM MY LOOKS */

          if (
            currentSource === 'looks'
          ) {

            instagramPanel.classList.add(
              'mimido-hidden'
            );


            field.classList.remove(
              'archive-instagram-mode'
            );


            contextHeading.textContent =
              'SHOW US A FEW LOOKS';


            contextText.textContent =
              "Share 3–5 looks you love, and we'll choose one to turn into your Mimido.";


            uploadFootnote.classList.remove(
              'mimido-hidden'
            );


            surpriseSourceProperty.value =
              'From My Looks';


            instagramProperty.value =
              '';


            instagramProperty.disabled =
              true;


            instagramNoteProperty.value =
              '';


            instagramNoteProperty.disabled =
              true;


            setMiniUploadSubmissionEnabled(
              true
            );
          }


          /* FROM MY INSTAGRAM */

          if (
            currentSource === 'instagram'
          ) {

            instagramPanel.classList.remove(
              'mimido-hidden'
            );


            field.classList.add(
              'archive-instagram-mode'
            );


            contextHeading.textContent =
              'SHARE YOUR INSTAGRAM';


            contextText.textContent =
              "Leave your Instagram @ and we'll choose one look from your feed to turn into your Mimido.";


            uploadFootnote.classList.add(
              'mimido-hidden'
            );


            surpriseSourceProperty.value =
              'From My Instagram';


            instagramProperty.disabled =
              false;


            instagramNoteProperty.disabled =
              false;


            setMiniUploadSubmissionEnabled(
              false
            );
          }
        }


        updateArchiveUploadText();
      }


      /* =================================================
         MODE TAB EVENTS
      ================================================= */

      modeTabs.forEach(
        tab => {

          tab.addEventListener(
            'click',
            event => {

              event.stopPropagation();


              currentMode =
                tab.dataset.mode;


              modeTabs.forEach(
                button => {

                  const active =
                    button.dataset.mode ===
                    currentMode;


                  button.classList.toggle(
                    'active',
                    active
                  );


                  button.setAttribute(
                    'aria-pressed',
                    active
                      ? 'true'
                      : 'false'
                  );
                }
              );


              renderArchiveMode();
            }
          );
        }
      );


      /* =================================================
         SOURCE TAB EVENTS
      ================================================= */

      sourceTabs.forEach(
        tab => {

          tab.addEventListener(
            'click',
            event => {

              event.stopPropagation();


              currentSource =
                tab.dataset.source;


              sourceTabs.forEach(
                button => {

                  const active =
                    button.dataset.source ===
                    currentSource;


                  button.classList.toggle(
                    'active',
                    active
                  );


                  button.setAttribute(
                    'aria-pressed',
                    active
                      ? 'true'
                      : 'false'
                  );
                }
              );


              renderArchiveMode();
            }
          );
        }
      );


      /* =================================================
         INSTAGRAM LINE ITEM PROPERTIES
      ================================================= */

      instagramHandle.addEventListener(
        'input',
        () => {

          instagramProperty.value =
            instagramHandle
              .value
              .trim();


          clearMiniError();
        }
      );


      instagramNote.addEventListener(
        'input',
        () => {

          instagramNoteProperty.value =
            instagramNote
              .value
              .trim();
        }
      );


      /* =================================================
         PER-MINI VALIDATION
      ================================================= */

      function validateMiniSelection() {

        clearMiniError();


        if (
          currentMode === 'surprise' &&
          currentSource === 'instagram'
        ) {

          if (
            !instagramHandle
              .value
              .trim()
          ) {

            showMiniError(
              `Please enter an Instagram @ for Mini ${number}.`
            );


            instagramHandle.focus();


            return {
              number,
              type: 'instagram'
            };
          }


          return null;
        }


        if (
          !hasMiniUploadedFiles()
        ) {

          showMiniError(
            `Please upload at least one reference for Mini ${number}.`
          );


          return {
            number,
            type: 'photo'
          };
        }


        return null;
      }


      miniValidators.push(
        validateMiniSelection
      );


      /* =================================================
         ACCORDION
      ================================================= */

      field.classList.remove(
        'active'
      );


      label.addEventListener(
        'click',
        () => {

          field.classList.toggle(
            'active'
          );


          const toggle =
            label.querySelector(
              '.archive-mini-toggle'
            );


          if (toggle) {

            toggle.textContent =
              field.classList.contains(
                'active'
              )
                ? '⌃'
                : '⌄';
          }
        }
      );


      field.dataset.archiveReady =
        'true';


      renderArchiveMode();
    }
  );


  if (
    !productForm.dataset.mimidoMiniValidationReady
  ) {

    const validateAllMinis =
      () => {

        const validationErrors =
          miniValidators
            .map(
              validateMini =>
                validateMini()
            )
            .filter(Boolean);


        if (!validationErrors.length) {
          return true;
        }


        showValidationDialog(
          validationErrors
        );


        return false;
      };


    const blockInvalidPurchase =
      event => {

        if (validateAllMinis()) {
          return;
        }


        event.preventDefault();

        event.stopImmediatePropagation();
      };


    const purchaseForms =
      new Set([
        productForm,
        ...Array.from(
          productFormComponent?.querySelectorAll(
            'form'
          ) || []
        )
      ]);


    purchaseForms.forEach(
      form => {
        form.addEventListener(
          'submit',
          blockInvalidPurchase,
          true
        );
      }
    );


    document.addEventListener(
      'click',
      event => {

        const eventPath =
          event.composedPath();


        const belongsToThisProduct =
          eventPath.some(
            element =>
              element === productForm ||
              element === productFormComponent ||
              (
                element instanceof Element &&
                productFormComponent?.contains(
                  element
                )
              )
          );


        const isPurchaseControl =
          eventPath.some(
            element =>
              element instanceof Element &&
              element.matches(
                'button[name="add"], input[name="add"], .shopify-payment-button, .shopify-payment-button__button, shopify-accelerated-checkout'
              )
          );


        if (
          !belongsToThisProduct ||
          !isPurchaseControl
        ) {
          return;
        }


        blockInvalidPurchase(
          event
        );
      },
      true
    );


    productForm.dataset.mimidoMiniValidationReady =
      'true';
  }


  return true;
}



/* =========================================================
   SINGLE CUSTOM MIMIDO
========================================================= */

function initSingleMimidoCreator() {

  const uploadWrap =
    getMimidoUploadWrap();


  if (!uploadWrap) {
    return false;
  }


  const productData =
    getMimidoProductData(
      uploadWrap
    );


  if (
    !productData.includes(
      'custom mimido from your photo'
    )
  ) {
    return false;
  }


  if (
    uploadWrap.dataset.singleMimidoReady ===
    'true'
  ) {
    return true;
  }


  let uploadFields =
    Array.from(
      uploadWrap.querySelectorAll(
        '.uploadkit-upload-field'
      )
    );


  if (!uploadFields.length) {

    uploadFields =
      Array.from(
        uploadWrap.querySelectorAll(
          '.uploadkit-uploader'
        )
      );
  }


  if (
    uploadFields.length !== 1
  ) {
    return false;
  }


  const uploadField =
    uploadFields[0];


  /* -----------------------------------------
     Real Shopify product form
  ----------------------------------------- */

  const addToCartButton =
    document.querySelector(
      'button[name="add"]'
    );


  const productForm =
    addToCartButton?.closest(
      'form.shopify-product-form'
    ) ||
    addToCartButton?.closest(
      'form'
    );


  if (!productForm) {
    return false;
  }


  const productFormComponent =
    productForm.closest(
      'product-form-component'
    );


  uploadWrap.dataset.singleMimidoReady =
    'true';


  document.body.classList.add(
    'single-mimido-mode-page'
  );


  /* =====================================================
     MAIN CREATION UI
  ===================================================== */

  const creationUI =
    document.createElement(
      'div'
    );


  creationUI.className =
    'mimido-creation-ui';


  creationUI.innerHTML = `

    <div class="mimido-creation-heading">
      HOW WOULD YOU LIKE TO CREATE YOUR MIMIDO?
    </div>


    <div
      class="mimido-mode-tabs"
      role="group"
      aria-label="Creation mode"
    >

      <button
        type="button"
        class="mimido-mode-tab active"
        data-mimido-mode="known"
        aria-pressed="true"
      >
        I KNOW WHAT I WANT
      </button>


      <button
        type="button"
        class="mimido-mode-tab"
        data-mimido-mode="surprise"
        aria-pressed="false"
      >
        SURPRISE ME
      </button>

    </div>


    <div class="mimido-content-panel">

      <div
        class="mimido-surprise-controls mimido-hidden"
      >

        <div class="mimido-surprise-question">
          HOW SHOULD WE CHOOSE YOUR LOOK?
        </div>


        <div
          class="mimido-source-tabs"
          role="group"
          aria-label="Surprise source"
        >

          <button
            type="button"
            class="mimido-source-tab active"
            data-mimido-source="looks"
            aria-pressed="true"
          >
            FROM MY LOOKS
          </button>


          <button
            type="button"
            class="mimido-source-tab"
            data-mimido-source="instagram"
            aria-pressed="false"
          >
            FROM MY INSTAGRAM
          </button>

        </div>

      </div>


      <div class="mimido-mode-context">

        <div class="mimido-context-heading">
          YOUR REFERENCES
        </div>

        <p class="mimido-context-text">
          Upload the reference(s) you'd like us to follow.
        </p>

      </div>


      <div
        class="mimido-mode-error"
        aria-live="polite"
      ></div>

    </div>
  `;


  uploadWrap.prepend(
    creationUI
  );


  const contentPanel =
    creationUI.querySelector(
      '.mimido-content-panel'
    );


  /* =====================================================
     INSTAGRAM PANEL
  ===================================================== */

  const instagramPanel =
    document.createElement(
      'div'
    );


  instagramPanel.className =
    'mimido-instagram-panel mimido-hidden';


  instagramPanel.innerHTML = `

    <div class="mimido-instagram-field">

      <label for="mimido-instagram-handle">
        Instagram @
      </label>

      <input
        id="mimido-instagram-handle"
        type="text"
        autocomplete="off"
        placeholder="@yourhandle"
      >

      <div class="mimido-instagram-help">
        Please make sure the account is public and includes clear photos we can reference.
      </div>

    </div>


    <div class="mimido-instagram-field">

      <label for="mimido-instagram-note">
        Anything we should know?

        <span class="mimido-optional-label">
          (optional)
        </span>

      </label>

      <textarea
        id="mimido-instagram-note"
        placeholder="A favorite style, something to avoid, or leave it completely to us."
      ></textarea>

    </div>
  `;


  /*
    UploadKit 原 uploader 搬进白色 inner panel
  */

  contentPanel.appendChild(
    uploadField
  );


  /*
    Surprise Me / From My Looks
    上传框下面的小字
  */

  const uploadFootnote =
    document.createElement(
      'div'
    );


  uploadFootnote.className =
    'mimido-upload-footnote mimido-hidden';


  contentPanel.appendChild(
    uploadFootnote
  );


  contentPanel.appendChild(
    instagramPanel
  );


  /* =====================================================
     SHOPIFY LINE ITEM PROPERTIES
  ===================================================== */

  function createPropertyInput(
    name,
    value = ''
  ) {

    const input =
      document.createElement(
        'input'
      );


    input.type =
      'hidden';


    input.name =
      `properties[${name}]`;


    input.value =
      value;


    productForm.appendChild(
      input
    );


    return input;
  }


  const creationModeProperty =
    createPropertyInput(
      'Creation Mode',
      'I Know What I Want'
    );


  const surpriseSourceProperty =
    createPropertyInput(
      'Surprise Source'
    );


  surpriseSourceProperty.disabled =
    true;


  const instagramProperty =
    createPropertyInput(
      'Instagram @'
    );


  instagramProperty.disabled =
    true;


  const instagramNoteProperty =
    createPropertyInput(
      'Surprise Note'
    );


  instagramNoteProperty.disabled =
    true;


  /* =====================================================
     STATE
  ===================================================== */

  let currentMode =
    'known';


  let currentSource =
    'looks';


  const modeTabs =
    creationUI.querySelectorAll(
      '.mimido-mode-tab'
    );


  const sourceTabs =
    creationUI.querySelectorAll(
      '.mimido-source-tab'
    );


  const surpriseControls =
    creationUI.querySelector(
      '.mimido-surprise-controls'
    );


  const contextHeading =
    creationUI.querySelector(
      '.mimido-context-heading'
    );


  const contextText =
    creationUI.querySelector(
      '.mimido-context-text'
    );


  const errorBox =
    creationUI.querySelector(
      '.mimido-mode-error'
    );


  const instagramHandle =
    instagramPanel.querySelector(
      '#mimido-instagram-handle'
    );


  const instagramNote =
    instagramPanel.querySelector(
      '#mimido-instagram-note'
    );


  const validationDialog =
    document.createElement(
      'dialog'
    );


  validationDialog.className =
    'mimido-single-validation-dialog';


  validationDialog.setAttribute(
    'aria-labelledby',
    'mimido-single-validation-title'
  );


  validationDialog.innerHTML = `
    <div class="mimido-single-validation-dialog__content">
      <button
        type="button"
        class="mimido-single-validation-dialog__close"
        aria-label="Close"
      >
        ×
      </button>
      <h2 id="mimido-single-validation-title">
        One more thing!
      </h2>
      <p class="mimido-single-validation-dialog__intro">
        Please complete the following before continuing.
      </p>
      <ul class="mimido-single-validation-dialog__list"></ul>
      <button
        type="button"
        class="button mimido-single-validation-dialog__ok"
      >
        OK
      </button>
    </div>
  `;


  document.body.appendChild(
    validationDialog
  );


  const validationDialogList =
    validationDialog.querySelector(
      '.mimido-single-validation-dialog__list'
    );


  const validationDialogClose =
    validationDialog.querySelector(
      '.mimido-single-validation-dialog__close'
    );


  const validationDialogOk =
    validationDialog.querySelector(
      '.mimido-single-validation-dialog__ok'
    );


  let validationDialogTrigger =
    null;


  function closeValidationDialog() {

    if (validationDialog.open) {
      validationDialog.close();
    }
  }


  function showValidationDialog(
    type,
    isDynamicCheckout
  ) {

    validationDialogList.textContent =
      '';


    const item =
      document.createElement(
        'li'
      );


    if (type === 'photo') {

      item.textContent =
        isDynamicCheckout
          ? 'Please upload at least one photo before continuing.'
          : 'Please upload at least one photo before adding your Mimido to the cart.';
    } else if (type === 'instagram') {

      item.textContent =
        isDynamicCheckout
          ? 'Please enter your Instagram @ before continuing.'
          : 'Please enter your Instagram @ before adding your Mimido to the cart.';
    }


    validationDialogList.appendChild(
      item
    );


    if (!validationDialog.open) {

      validationDialogTrigger =
        document.activeElement;


      validationDialog.showModal();
    }


    requestAnimationFrame(
      () => {
        validationDialogClose.focus();
      }
    );
  }


  validationDialogClose.addEventListener(
    'click',
    closeValidationDialog
  );


  validationDialogOk.addEventListener(
    'click',
    closeValidationDialog
  );


  validationDialog.addEventListener(
    'cancel',
    event => {

      event.preventDefault();


      closeValidationDialog();
    }
  );


  validationDialog.addEventListener(
    'click',
    event => {

      if (event.target === validationDialog) {
        closeValidationDialog();
      }
    }
  );


  validationDialog.addEventListener(
    'close',
    () => {

      validationDialogTrigger?.focus?.();


      validationDialogTrigger =
        null;
    }
  );


  /* =====================================================
     CHECK WHETHER PHOTOS EXIST
  ===================================================== */

  function hasUploadedFiles() {

    const uploadedImage = new FormData(
      productForm
    ).get(
      'properties[_Upload  Images]'
    );


    if (
      typeof uploadedImage !== 'string' ||
      !uploadedImage.trim()
    ) {
      return false;
    }


    try {
      const uploadedImageUrl =
        new URL(
          uploadedImage.trim()
        );


      return (
        uploadedImageUrl.protocol === 'https:' ||
        uploadedImageUrl.protocol === 'http:'
      );
    } catch (_) {
      return false;
    }
  }


  /* =====================================================
     ERROR HELPERS
  ===================================================== */

  function showError(
    message
  ) {

    errorBox.textContent =
      message;


    errorBox.classList.add(
      'visible'
    );


    errorBox.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest'
    });
  }


  function clearError() {

    errorBox.textContent =
      '';


    errorBox.classList.remove(
      'visible'
    );
  }


  /* =====================================================
     UPLOAD BUTTON TEXT
  ===================================================== */

  function updateUploadButtonText() {

    const uploadButton =
      uploadField.querySelector(
        '.uploadkit-button'
      );


    if (
      !uploadButton ||
      hasUploadedFiles()
    ) {
      return;
    }


    const desiredText =
      currentMode === 'surprise' &&
      currentSource === 'looks'
        ? 'Add 3–5 looks'
        : 'Add photos';


    if (
      uploadButton
        .textContent
        .trim() !== desiredText
    ) {

      uploadButton.textContent =
        desiredText;
    }
  }


  /* =====================================================
     RENDER MODE
  ===================================================== */

  function renderMode() {

    clearError();


    /* -------------------------
       I KNOW WHAT I WANT
    ------------------------- */

    if (
      currentMode === 'known'
    ) {

      surpriseControls.classList.add(
        'mimido-hidden'
      );


      uploadField.classList.remove(
        'mimido-hidden'
      );


      instagramPanel.classList.add(
        'mimido-hidden'
      );


      contextHeading.textContent =
        'YOUR REFERENCES';


      contextText.textContent =
        "Upload the reference(s) you'd like us to follow.";


      uploadFootnote.textContent =
        '';


      uploadFootnote.classList.add(
        'mimido-hidden'
      );


      creationModeProperty.value =
        'I Know What I Want';


      surpriseSourceProperty.value =
        '';


      surpriseSourceProperty.disabled =
        true;


      instagramProperty.value =
        '';


      instagramProperty.disabled =
        true;


      instagramNoteProperty.value =
        '';


      instagramNoteProperty.disabled =
        true;
    }


    /* -------------------------
       SURPRISE ME
    ------------------------- */

    if (
      currentMode === 'surprise'
    ) {

      surpriseControls.classList.remove(
        'mimido-hidden'
      );


      creationModeProperty.value =
        'Surprise Me';


      surpriseSourceProperty.disabled =
        false;


      /* FROM MY LOOKS */

      if (
        currentSource === 'looks'
      ) {

        uploadField.classList.remove(
          'mimido-hidden'
        );


        instagramPanel.classList.add(
          'mimido-hidden'
        );


        contextHeading.textContent =
          'SHOW US A FEW LOOKS';


        contextText.textContent =
          "Share 3–5 looks you love, and we'll choose one to turn into your Mimido.";


        uploadFootnote.textContent =
          'Multiple photos per look are welcome.';


        uploadFootnote.classList.remove(
          'mimido-hidden'
        );


        surpriseSourceProperty.value =
          'From My Looks';


        instagramProperty.value =
          '';


        instagramProperty.disabled =
          true;


        instagramNoteProperty.value =
          '';


        instagramNoteProperty.disabled =
          true;
      }


      /* FROM MY INSTAGRAM */

      if (
        currentSource === 'instagram'
      ) {

        uploadField.classList.add(
          'mimido-hidden'
        );


        instagramPanel.classList.remove(
          'mimido-hidden'
        );


        contextHeading.textContent =
          'SHARE YOUR INSTAGRAM';


        contextText.textContent =
          "Leave your Instagram @ and we'll choose one look from your feed to turn into your Mimido.";


        uploadFootnote.textContent =
          '';


        uploadFootnote.classList.add(
          'mimido-hidden'
        );


        surpriseSourceProperty.value =
          'From My Instagram';


        instagramProperty.disabled =
          false;


        instagramNoteProperty.disabled =
          false;
      }
    }


    updateUploadButtonText();
  }


  /* =====================================================
     MAIN TABS
  ===================================================== */

  modeTabs.forEach(
    (tab) => {

      tab.addEventListener(
        'click',
        () => {

          currentMode =
            tab.dataset.mimidoMode;


          modeTabs.forEach(
            (button) => {

              const active =
                button.dataset.mimidoMode ===
                currentMode;


              button.classList.toggle(
                'active',
                active
              );


              button.setAttribute(
                'aria-pressed',
                active
                  ? 'true'
                  : 'false'
              );
            }
          );


          renderMode();
        }
      );
    }
  );


  /* =====================================================
     SURPRISE SOURCE TABS
  ===================================================== */

  sourceTabs.forEach(
    (tab) => {

      tab.addEventListener(
        'click',
        () => {

          currentSource =
            tab.dataset.mimidoSource;


          sourceTabs.forEach(
            (button) => {

              const active =
                button.dataset.mimidoSource ===
                currentSource;


              button.classList.toggle(
                'active',
                active
              );


              button.setAttribute(
                'aria-pressed',
                active
                  ? 'true'
                  : 'false'
              );
            }
          );


          renderMode();
        }
      );
    }
  );


  /* =====================================================
     INSTAGRAM INPUTS
  ===================================================== */

  instagramHandle.addEventListener(
    'input',
    () => {

      instagramProperty.value =
        instagramHandle
          .value
          .trim();


      clearError();
    }
  );


  instagramNote.addEventListener(
    'input',
    () => {

      instagramNoteProperty.value =
        instagramNote
          .value
          .trim();
    }
  );


  /* =====================================================
     VALIDATION
  ===================================================== */

  function validateMimidoSelection(
    isDynamicCheckout = false
  ) {

    clearError();


    if (
      currentMode === 'known'
    ) {

      if (
        !hasUploadedFiles()
      ) {

        showError(
          'Please upload at least one photo before adding your Mimido to the cart.'
        );


        showValidationDialog(
          'photo',
          isDynamicCheckout
        );


        return false;
      }


      return true;
    }


    if (
      currentMode === 'surprise' &&
      currentSource === 'looks'
    ) {

      if (
        !hasUploadedFiles()
      ) {

        showError(
          'Please upload at least one photo before adding your Mimido to the cart.'
        );


        showValidationDialog(
          'photo',
          isDynamicCheckout
        );


        return false;
      }


      return true;
    }


    if (
      currentMode === 'surprise' &&
      currentSource === 'instagram'
    ) {

      const handle =
        instagramHandle
          .value
          .trim();


      if (!handle) {

        showError(
          'Please enter your Instagram @ so we know where to choose your look from.'
        );


        showValidationDialog(
          'instagram',
          isDynamicCheckout
        );


        instagramHandle.focus();


        return false;
      }

      return true;
    }


    return true;
  }


  /* =====================================================
     ADD TO CART
  ===================================================== */

  function isDynamicCheckoutPurchase(
    event
  ) {

    const eventPath =
      event.composedPath();


    return eventPath.some(
      element =>
        element instanceof Element &&
        (
          element.matches(
            '.shopify-payment-button, .shopify-payment-button__button, shopify-accelerated-checkout'
          ) ||
          element.closest?.(
            '.accelerated-checkout-block'
          )
        )
    );
  }


  const blockInvalidPurchase =
    event => {

      if (
        validateMimidoSelection(
          isDynamicCheckoutPurchase(
            event
          )
        )
      ) {
        return;
      }


      event.preventDefault();

      event.stopImmediatePropagation();
    };


  if (
    !productForm.dataset.mimidoSingleValidationReady
  ) {

    const purchaseForms =
      new Set([
        productForm,
        ...Array.from(
          productFormComponent?.querySelectorAll(
            'form'
          ) || []
        )
      ]);


    purchaseForms.forEach(
      form => {
        form.addEventListener(
          'submit',
          blockInvalidPurchase,
          true
        );
      }
    );


    document.addEventListener(
      'click',
      event => {

        const eventPath =
          event.composedPath();


        const belongsToThisProduct =
          eventPath.some(
            element =>
              element === productForm ||
              element === productFormComponent ||
              (
                element instanceof Element &&
                productFormComponent?.contains(
                  element
                )
              )
          );


        const isPurchaseControl =
          eventPath.some(
            element =>
              element instanceof Element &&
              element.matches(
                'button[name="add"], input[name="add"], .shopify-payment-button, .shopify-payment-button__button, shopify-accelerated-checkout'
              )
          );


        if (
          !belongsToThisProduct ||
          !isPurchaseControl
        ) {
          return;
        }


        blockInvalidPurchase(
          event
        );
      },
      true
    );


    productForm.dataset.mimidoSingleValidationReady =
      'true';
  }


  renderMode();


  return true;
}



/* =========================================================
   INITIALIZATION
========================================================= */

function initCasaMimidoUploadUI() {

  const uploadWrap =
    getMimidoUploadWrap();


  if (!uploadWrap) {
    return false;
  }


  const productData =
    getMimidoProductData(
      uploadWrap
    );


  if (
    productData.includes(
      'mini archive'
    )
  ) {

    return initMiniArchiveAccordion();
  }


  if (
    productData.includes(
      'custom mimido from your photo'
    )
  ) {

    return initSingleMimidoCreator();
  }


  return true;
}


function startCasaMimidoUploadUI() {

  if (
    initCasaMimidoUploadUI()
  ) {
    return;
  }


  const observer =
    new MutationObserver(
      () => {

        if (
          initCasaMimidoUploadUI()
        ) {

          observer.disconnect();
        }
      }
    );


  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );


  setTimeout(
    () => {

      initCasaMimidoUploadUI();

      observer.disconnect();

    },
    5000
  );
}


if (
  document.readyState === 'loading'
) {

  document.addEventListener(
    'DOMContentLoaded',
    startCasaMimidoUploadUI
  );

} else {

  startCasaMimidoUploadUI();
}
